(function () {
  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {
    var atcButton = document.getElementById('addToCart');
    if (!atcButton) return;

    var label = atcButton.querySelector('[data-pf-type="Text"]') || atcButton;
    var defaultLabel = label.textContent;

    var hint = document.createElement('p');
    hint.className = 'flavor-picker-hint';
    hint.setAttribute('aria-live', 'polite');
    hint.textContent = 'Please select a flavor for all 6 jars.';
    atcButton.insertAdjacentElement('afterend', hint);

    function selects() {
      // Bold Options builds .bold_option_set itself, asynchronously, so it
      // may not exist in the DOM yet -- query fresh each time rather than
      // caching a reference to it.
      return document.querySelectorAll('.bold_option_set select');
    }

    function isComplete() {
      var els = selects();
      if (els.length === 0) return false;
      for (var i = 0; i < els.length; i++) {
        if (!els[i].value) return false;
      }
      return true;
    }

    function refresh() {
      var complete = isComplete();
      atcButton.disabled = !complete;
      hint.style.display = complete ? 'none' : 'block';
      label.textContent = complete ? defaultLabel : 'Select all 6 flavors';
    }

    // Lock the button immediately -- isComplete() is false with zero
    // selects found, so this holds until Bold's markup actually exists.
    refresh();

    // Delegated on document (not .bold_option_set) since that container
    // doesn't exist in the DOM until Bold builds it after this script runs.
    document.addEventListener('change', function (e) {
      if (e.target.matches && e.target.matches('.bold_option_set select')) {
        refresh();
      }
    });

    // Also poll briefly in case Bold's injection completes without the
    // shopper touching anything yet.
    var attempts = 0;
    var poll = setInterval(function () {
      attempts++;
      refresh();
      if (selects().length >= 6 || attempts > 50) clearInterval(poll);
    }, 200);
  });
})();
